'use client';

import type { ProviderEntry } from '@lib/analytics/cookie-registry';
import { Minus, Plus } from '@modules/common/icons';
import { useState } from 'react';
import CookieItem from './cookie-item';
import ProviderInfo from './provider-info';

const ProviderRow = ({ provider }: { provider: ProviderEntry }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const Icon = isExpanded ? Minus : Plus;
  const action = isExpanded ? 'Collapse' : 'Expand';

  return (
    <div className="rounded-lg border border-brand-neutral-100 overflow-hidden">
      <div className="flex items-start gap-2 p-4">
        <div className="flex flex-col gap-2 flex-1 min-w-0">
          <ProviderInfo provider={provider} isExpanded={isExpanded} />
        </div>
        <button
          type="button"
          onClick={() => setIsExpanded((v) => !v)}
          aria-expanded={isExpanded}
          aria-label={`${action} ${provider.name}`}
          className="shrink-0 cursor-pointer p-1 -mr-1 text-brand-neutral-900"
        >
          <Icon size="16" />
        </button>
      </div>
      {isExpanded && provider.cookies.length > 0 && (
        <div className="border-t border-brand-neutral-100 px-4 py-3 flex flex-col gap-2">
          {provider.cookies.map((cookie) => (
            <CookieItem key={cookie.name} cookie={cookie} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProviderRow;
